export class ArrayUtil {
  static filterOutNull<T>(array: T[]): T[] {
    return array.filter((value) => value != null);
  }

  /**
   * Removes duplicate elements from a flat array.
   */
  public static unique<T>(array: T[]): T[] {
    return [...Array.from(new Set(array))];
  }
}
